import {getPrivateAxios} from '../../libs';

export interface CreateTeamInviteDto {
  email: string;
}

export const fetchTeamInviteCreate = async (data: CreateTeamInviteDto) => {
  const response = await getPrivateAxios().post('/teams/invite', data);
  return response.data;
};
